enum WORK_UNIT_STATUS {
  Aborted = '6',
  Complete = '4',
  Error = '5',
  Executing = '3',
  Skipped = '7',
  Started = '2',
  Queued = '1',
}
export default WORK_UNIT_STATUS;
